module.exports = __webpack_public_path__ + "static/bootstrap-grid-c653866a835e82ec113aba7c0e49c9a8.jpg";